import { View } from "@react-pdf/renderer";

import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { ResumePDFDescription, TemplateNineteenPDFSection, TemplateNineteenSection } from "./common";

export const Custom = ({
  heading,
  custom,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateNineteenSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription
          items={descriptions}
          enableHighlight={enableHighlight}
          enableMistakeHighlight={enableMistakeHighlight}
        />
      </View>
    </TemplateNineteenSection>
  );
};
